import { useCallback, useMemo } from 'react';

import { PageHeaderDropdownMenu } from 'components/Page/Header/PageHeaderDropdownMenu';
import { LANGUAGES } from 'utils/constants';

import { LanguageSelectionMenuItem } from './LanguageSelectionMenuItem';
import { LanguageSelectionMenuTitle } from './LanguageSelectionMenuTitle';

type Props = {
  pageUrl: Record<UserLocale, string>;
};

export function LanguageSelectionMenu({ pageUrl }: Props) {
  const locales = Object.keys(LANGUAGES) as UserLocale[];

  const localesToShow = useMemo(
    () => locales.filter((key) => key !== CURRENT_LOCALE),
    [locales],
  );

  const titleComponentFunction = useCallback(
    (open: boolean) => <LanguageSelectionMenuTitle open={open} />,
    [],
  );

  return (
    <PageHeaderDropdownMenu
      hideArrow={{ lg: true }}
      title={titleComponentFunction}
      data-qa-id="language-dropdown"
      aria-label={getText('Select language')}
    >
      {localesToShow.map((locale) => (
        <LanguageSelectionMenuItem
          key={locale}
          locale={locale}
          localeUrl={pageUrl[locale]}
        />
      ))}
    </PageHeaderDropdownMenu>
  );
}
